var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`SisrLoader d-flex flex-column justify-content-center align-items-center ${
    _vm.color ? _vm.color : 'text-primary'
  }`},[(_vm.label)?_c('strong',[_vm._v(_vm._s(_vm.label))]):_vm._e(),(_vm.loaderSize === 'small')?_c('div',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status"}}):_vm._e(),(_vm.loaderSize === 'default')?_c('div',{class:`spinner-border ${_vm.label ? 'm-3' : 'm-5'}`,attrs:{"role":"status"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }